import { storage } from '@/plugins/firebase'

/**
 * Safe single path segment for Storage (organization folder name).
 * @param {string} value
 * @param {number} maxLen
 * @returns {string}
 */
export function sanitizeSurveyWorkStorageSegment (value, maxLen = 120) {
  return String(value || '')
    .trim()
    .replace(/[/\\#?]+/g, '_')
    .replace(/\s+/g, ' ')
    .slice(0, maxLen)
    .trim() || 'organization'
}

function buildStoredFileName (originalName) {
  const base = String(originalName || 'chart').split(/[/\\]/).pop()
  const lastDot = base.lastIndexOf('.')
  const ext = lastDot >= 0
    ? base.slice(lastDot + 1).toLowerCase().replace(/[^a-z0-9]/g, '') || 'bin'
    : 'bin'
  const stem = lastDot >= 0 ? base.slice(0, lastDot) : base
  const safeStem = sanitizeSurveyWorkStorageSegment(stem, 60).replace(/[^\w.-]/g, '_') || 'chart'
  return `${safeStem}_${Date.now()}.${ext}`
}

/**
 * Uploads survey work pluviometric chart to default bucket.
 * Path: surveyPluviometricCharts/{organizationName}/{surveyWorkId}/{fileName}
 * @param {File} file
 * @param {string} organizationName
 * @param {string} surveyWorkId
 * @returns {Promise<string>} Storage path stored in Firestore pluviometricChart
 */
export async function uploadSurveyWorkPluviometricChart (file, organizationName, surveyWorkId) {
  const orgSeg = sanitizeSurveyWorkStorageSegment(organizationName, 100)
  const fileName = buildStoredFileName(file.name)
  const workSeg = sanitizeSurveyWorkStorageSegment(surveyWorkId, 80)
  const filePath = `surveyPluviometricCharts/${orgSeg}/${workSeg}/${fileName}`
  await storage.ref().child(filePath).put(file)
  return filePath
}

/**
 * Best-effort delete; ignores missing object.
 * @param {string} storagePath
 * @returns {Promise<void>}
 */
export async function deleteSurveyWorkPluviometricChartAtPath (storagePath) {
  if (!storagePath || typeof storagePath !== 'string' || !storagePath.trim()) return
  const path = storagePath.trim()
  try {
    await storage.ref().child(path).delete()
  } catch (e) {
    const code = e && e.code
    if (code !== 'storage/object-not-found') {
      console.warn('surveyWork chart storage delete:', code, path)
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/surveyWorkPluviometricChart.js